export function mapTypeGroup(typeGroup: string) {
  if (typeGroup === "Mechanical" || typeGroup === "Performance")
    return typeGroup;

  return "Other";
}